<template>
    <div class="nav-item-profile">

        <button class="btn mb-2 pointer d-md-none d-sm-block b-orange" @click="displayMenu">
            <i class="fas fa-bars p-1" aria-hidden="true">
            </i>
            <span class="ml-2">Menu</span>
        </button>

        <b-nav vertical class="w-100" id="navbar-profile">
            <h5 class="font-gray-dark p-1 mb-2">Publicar empleo</h5>


            <!--EditElement -->
            <div v-if="jobParent.id">

                <JobNavBar :jobParent="jobParent" v-if="jobParent.id"/>

                <b-nav-item active to="/job/generate">
                    <i class="fas fa-info-circle"></i>
                    Bienvenida
                </b-nav-item>
                <b-nav-item v-intro="introTexts.job_create"
                            v-intro-position="'right'"
                            :to="'/job/generate/' + jobParent.id + '/name'">
                    <i class="fas fa-pen"></i>
                    Información de vacante
                </b-nav-item>
                <b-nav-item v-intro="introTexts.job_match"
                            v-intro-position="'right'"
                            :to="'/job/generate/' + jobParent.id + '/match'">
                    <div class="d-flex">
                        <i class="fas fa-medal mr-1 mt-2"></i>
                        <p class="text-left m-0">
                            Compatibilidad
                            <br>(Match personalizado)
                        </p>
                    </div>
                </b-nav-item>
                <b-nav-item v-intro="introTexts.job_delete"
                            v-intro-position="'right'"
                            :to="'/job/generate/' + jobParent.id + '/remove'">
                    <i class="fas fa-backspace"></i>
                    Eliminar vacante
                </b-nav-item>
            </div>
            <!--NewElement-->
            <div v-else>
                <b-nav-item to="/job/generate">
                    <i class="fas fa-info-circle"></i>
                    Bienvenida
                </b-nav-item>
                <b-nav-item v-intro="introTexts.job_create"
                            v-intro-position="'right'"
                            to="/job/generate/name">
                    <i class="fas fa-pen"></i>
                    Crear vacante
                </b-nav-item>
            </div>
            <b-dropdown-divider></b-dropdown-divider>
            <b-nav-item v-intro="introTexts.callback_jobs"
                        v-intro-position="'right'"

                    to="/perfil/empleos">
                <i class="fas fa-home"></i>
                Volver a Empleos
            </b-nav-item>
        </b-nav>
    </div>
</template>
<script>
import JobNavBar from './JobNavBar'
import $ from "jquery";

export default {
    name: 'NavBarJob',
    props: {
        jobParent: Object
    },
    components: {
        'JobNavBar': JobNavBar
    },
    data() {
        return {
            showIntro: false,
            introTexts: {
                job_create: "Aquí deberás agregar la información correspondiente del empleo",
                callback_jobs: "Regresa a la sección de empleos creados",
                job_delete: "Aquí se eliminar la vacante(Empleo)",
                job_match: "Podrán modificar los puntos a considerar por la empresa de igual forma editar " +
                    "el porcentaje para el Match",
            },
            displayButtons: false,
        }
    },
    created() {
        this.bus.$on('display-jobs-intro', v => {
            var intro_ =  this.$intro().setOptions({
                            nextLabel: 'Siguiente',
                            prevLabel: 'Anterior',
                            doneLabel: 'Hecho',
                            skipLabel:'Cancelar'})
            this.displayButtons = true
            intro_.onexit(() => {
                this.displayButtons = false
            })
            intro_.start();
        })
    },
    methods: {
        displayMenu() {
            let navbar = $('#navbar-profile')
            if (navbar.hasClass('d-none')) {
                navbar.removeClass('d-none')
                $('ul.nav').addClass('navbar-responsive-active')
            } else {
                $('ul.nav').removeClass('navbar-responsive-active')
                navbar.addClass('d-none')
            }
        },
        noDisplay() {
            swal('Es necesario ingresar la información del curso')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/components/NavBarJob.vue